/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React from "react";
import {Layout, FloatButton, Modal} from "antd";
import {BugOutlined, InfoCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {releaseNotes} from "../release-notes";

export default function Footer(props: any) {

    const bugMailSubject = "[BugReport]: Was ist das Problem?"
    const bugMailBody = "Hallo ITP-Support,\n" +
        "folgendes Problem ist mir aufgefallen:\n" +
        "\n" +
        "Breadcrumb: z.b. Home/Kunde/Testkunde\n" +
        "Der Breadcrumb findet sich im oberen Bereich des Hauptdialogs. Diese Angabe hilft uns das betroffene Fenster/den betroffenen Datensatz schneller zu finden.\n\n" +
        "Was war mein Ziel?\n" +
        "Hier hilft uns eine möglichst genaue Beschreibung der geplanten Tätigkeit, um diese nachstellen zu können.\n" +
        "    - Z.B. Ich wollte die Adresse des Kundendatensatz anpassen\n" +
        "\n" +
        "Was ist mein erwartetes Ergebnis?\n" +
        "Was sollte passieren? Diese Information benötigen wir, um evtl. unerwartete Workflows oder neue Anforderungen zu erkennen.\n" +
        "    - Ich wollte den angepassten Datensatz speichern.\n" +
        "\n" +
        "Was war das reale Ergebnis?\n" +
        "Hier ist eine möglichst präzise Beschreibung des Fehlverhaltens hilfreich. Gerne können auch Screenshots beigefügt werden.\n" +
        "    - Die Änderung wurde nicht gespeichert.\n" +
        "    - Es kam die Fehlermeldung „Der Datensatz ist nicht vorhanden“\n"

    const showReleaseInfos = () => {
        Modal.info(
            {
                title: "Release Informationen",
                content: <div style={{height: '50vh', width: '100%', overflowY: 'scroll'}}>{releaseNotes}</div>,
                width: '75vw',
                maskClosable: true,
                okText: 'Schließen',
            }
        )
    }

    const help_float = (
        <FloatButton.Group
            trigger='hover'
            style={{bottom: 18, right: 24}}
            icon={<QuestionCircleOutlined/>}
        >
            <FloatButton
                tooltip={"Release Informationen ansehen"}
                icon={<InfoCircleOutlined />}
                onClick={() => showReleaseInfos()}
            />
            <FloatButton
                tooltip={"Einen Fehler melden"}
                icon={<BugOutlined />}
                href={
                    'mailto:support@itp-consult.de?cc=MPE@bendergruppe.com&subject='
                    + bugMailSubject
                    + '&body='
                    + bugMailBody.replaceAll("\n", "%0D%0A")
                }
            />
        </FloatButton.Group>
    )

    return (
        <Layout.Footer style={{padding: 24}}>
            © 2021 - {dayjs().year()} ITP-Consult Gesellschaft für IT-Beratung mbH
            {help_float}
        </Layout.Footer>
    );
}